const pt_br = {
  autor: 'autor | autores',
  baixar_trabalho: 'Baixar o @:trabalho_alt.s',
  corpo_editorial: 'Corpo Editorial',
  eixo: 'eixo | eixos',
  eixo_alt: {
    s: 'eixo',
    p: 'eixos'
  },
  eixo_tematico: '@:eixo_alt.s Temático | @:eixo_alt.p Temáticos',
  eixos_publicados: '@:eixo_alt.p Publicados',
  inicio: 'início',
  instituicao: 'instituição | instituições',
  nao_ha_trabalhos_pesquisa: 'Não há @:trabalho_alt.p que correspondem à sua pesquisa',
  nenhuma_pessoa_encontrada: 'Nenhuma pessoa encontrada',
  nenhuma_pessoa_encontrada_com_letra: '@:nenhuma_pessoa_encontrada com a letra \"{letra}\"',
  palavra_chave: 'palavra-chave | palavras-chave',
  pesquisa: 'pesquisa',
  placeholder_pesquise_por_nome: 'Pesquise por nome, filiação, ...',
  placeholder_pesquise_por_titulo: 'Pesquise por título, autor, ...',
  publicacao: 'publicação | publicações',
  resumo: 'resumo | resumos',
  trabalho: 'trabalho | trabalhos',
  trabalho_alt: {
    s: 'trabalho',
    p: 'trabalhos'
  },
  trabalho_publicado: '@:trabalho_alt.s publicado | @:trabalho_alt.p publicados',
}


const en = {
  autor: 'author | authors',
  baixar_trabalho: 'Download @:trabalho_alt.s',
  corpo_editorial: 'Organizing Committee',
  eixo: 'theme | themes',
  eixo_alt: {
    s: 'theme',
    p: 'themes'
  },
  eixo_tematico: 'thematic area | thematic areas',
  eixos_publicados: 'published @:eixo_alt.p',
  inicio: 'home',
  instituicao: 'institution | institutions',
  nao_ha_trabalhos_pesquisa: 'There is no @:trabalho_alt.p matched your search',
  nenhuma_pessoa_encontrada: 'No people found',
  nenhuma_pessoa_encontrada_com_letra: '@:nenhuma_pessoa_encontrada with the letter \"{letra}\"',
  palavra_chave: 'keyword | keywords',
  pesquisa: 'search',
  placeholder_pesquise_por_nome: 'Search for name, membership, ...',
  placeholder_pesquise_por_titulo: 'Search for title, author, ...',
  publicacao: 'paper | papers',
  resumo: 'abstract | abstracts',
  trabalho: 'work | works',
  trabalho_alt: {
    s: 'work',
    p: 'works'
  },
  trabalho_publicado: 'published @:trabalho_alt.s | published @:trabalho_alt.p',
}


const i18n = {
  messages: {
    pt_br: pt_br,
    en: en
  }
}

export { pt_br, en, i18n }


// WEBPACK FOOTER //
// ./src/langs/anais.js